import { call, put, take, takeEvery } from 'redux-saga/effects';
import * as storage from 'utils/storage';
import {
  fetchCollections,
  fetchCollectionBySlug,
  fetchDefaultCollection,
} from '../actions/collectionActions';
import { fetchWidgetsList } from '../actions/widgetActions';
import Api from 'api/collections';

export function* fetchCollectionsSaga() {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.fetchCollections, {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    yield put({ type: fetchCollections.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: fetchCollections.success, payload: err.message });
  }
}

export function* fetchCollectionBySlugSaga(action) {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.fetchCollectionBySlug(action.payload.slug), {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    const { widgets, ...rest } = response.data;
    yield put({ type: fetchCollectionBySlug.success, payload: rest });
    yield put({ type: fetchWidgetsList.success, payload: widgets });
  } catch (error) {
    const err = error as Error;
    yield put({ type: fetchCollections.success, payload: err.message });
  }
}

export function* fetchDefaultCollectionSaga() {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.fetchDefaultCollection, {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    const { widgets, ...rest } = response.data;
    yield put({ type: fetchDefaultCollection.success, payload: rest });
    yield put({ type: fetchWidgetsList.success, payload: widgets });
  } catch (error) {
    const err = error as Error;
    yield put({ type: fetchCollections.success, payload: err.message });
  }
}

export function* watchFetchCollectionBySlug() {
  yield takeEvery(fetchCollectionBySlug.request, fetchCollectionBySlugSaga);
}

export function* watchFetchDefaultCollection() {
  yield take(fetchDefaultCollection.request);
  yield call(fetchDefaultCollectionSaga);
}

export function* watchFetchCollections() {
  yield take(fetchCollections.request);
  yield call(fetchCollectionsSaga);
}
